module.exports = __webpack_public_path__ + "static/media/Final logo_full colour.dbf366f0.png";